import React, { useState } from 'react';

function StepThree({ formData, onNext }) {
    const [hasMedicalCondition, setHasMedicalCondition] = useState(formData.hasMedicalCondition || '');
    const [medicalDetails, setMedicalDetails] = useState(formData.medicalDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!hasMedicalCondition) {
            setError('Please select Yes or No.');
            return;
        }

        if (hasMedicalCondition === 'yes' && !medicalDetails.trim()) {
            setError('Please give details about your medical condition.');
            return;
        }

        setError('');
        onNext({ hasMedicalCondition, medicalDetails });
    };

    const isFormValid =
        hasMedicalCondition === 'no' ||
        (hasMedicalCondition === 'yes' && medicalDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">General Health</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Do you have any current medical conditions? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="medicalCondition"
                            id="medicalYes"
                            value="yes"
                            checked={hasMedicalCondition === 'yes'}
                            onChange={() => setHasMedicalCondition('yes')}
                        />
                        <label className="form-check-label" htmlFor="medicalYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="medicalCondition"
                            id="medicalNo"
                            value="no"
                            checked={hasMedicalCondition === 'no'}
                            onChange={() => setHasMedicalCondition('no')}
                        />
                        <label className="form-check-label" htmlFor="medicalNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {hasMedicalCondition === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">Please give details:</label>
                    <textarea
                        className="form-control"
                        placeholder="Please give details"
                        rows="4"
                        value={medicalDetails}
                        onChange={e => setMedicalDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepThree;
